module.exports = __webpack_public_path__ + "static/media/Produktinformationen_ Hygienestation_HS_200.pdf";